<template>
    <div class="section-wrap">
        <div class="container">
            <div class="card-wrap">
                <div class="card-box card-tab text-center">
                    <h5 style="margin: 100px 0">Please wait while we are processing your request...</h5>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
 
import {getJWTFromStorage, saveJWTToStorage} from '@/api/localStorage'

export default {
    name: 'paymentredirect',
    data () {
        return {
            userid: parseInt(getJWTFromStorage('userid')),
        }
    },
    created() {
        var obj = this.getRequestParameters();
        saveJWTToStorage('paymentdata', obj)
		var paymentJson = JSON.parse(obj)
        if(paymentJson != null && paymentJson.id && paymentJson.id.success)
            this.redirectPage(paymentJson.id.success);
        else
            this.redirectPage(0);
    },

    methods: {       
       getRequestParameters(){
            var reqParams = window.location.hash.split('?')[1];
			reqParams = decodeURIComponent(reqParams);
            var params = reqParams.split('&');
            var paramsJson = '{';
            for(var i=0; i< params.length; i++){
                paramsJson += '"' + params[i].split("=")[0] + '"' + ':' + params[i].split("=")[1];
				
                if(i != params.length-1)
                    paramsJson += ',';
            }          
            paramsJson += '}';           
            
            return JSON.parse(JSON.stringify(paramsJson));
        },        
        setHomePage (){
            this.fetchPaymentDetails();
        },

		async fetchPaymentDetails(){           
           this.redirectPage();
        },
        
        redirectPage(success){
            if(success){
                this.$router.replace(this.$route.query.redirect || '/paymentcomplete')
            }else{
                this.$router.replace(this.$route.query.redirect || '/paymenterror')
            }
        }     
  
    }
}
</script>



// WEBPACK FOOTER //
// src/components/paymentredirect.vue